import * as addToCalendar from '../../helpers/addToCalendar';
import moment from 'moment-timezone';
import Raven from 'raven-js';

import form from './form';
import infoTables from './infoTables';
import styles from '../../css/appointmentView.css';
import widgetModal from '../widgetModal';
import {
  createEl, // args: tag, classes, textNode, attributes
  createBtn, // args: classes, title
  getFormData, // args: form element
} from '../../helpers/domHelpers';
import { onFormSubmissionClick, onRequestSubmission } from '../../helpers/analytics'
import { findTimeText } from '../calendarView/calendar'
import { widgetCtrl as ctrl } from '../../widgetController';

function createCalIcon(name, srcString, href) {
  const icon = createEl('a', styles.calendarBtn, '', { target: 'blank', href });
  icon.append(
    createEl('img', styles.calendarIcon, '', { src: srcString }),
    createEl('span', styles.calendarName, name),
  );
  return icon;
}

function makeCalendarEvent() {
  const appointment = ctrl.getAppointmentInfo();
  const location = ctrl.getCurrentLocation();
  return {
    title: `First appointment at ${ctrl.getPracticeName()}`,
    start: moment.tz(appointment.start_datetime, ctrl.getTz()).format('YYYYMMDDTHHmmss'),
    end: moment.tz(appointment.start_datetime, ctrl.getTz()).add(appointment.length, 'minutes').format('YYYYMMDDTHHmmss'),
    address: `${location.street_address}, ${location.city}, ${location.state} ${location.zip}`,
  };
}

const appointmentView = {

  init() {
    this.appointmentInfoView = createEl('div', styles.appointmentInfoView);

    this.formView = this.initFormView();
    return this.appointmentInfoView;
  },

  initFooter() {
    const footer = createEl('div', styles.footer);
    footer.append(
    createEl('span', styles.footerText, 'Powered by Rooster Grin Media'),
      createEl('img', styles.footerLogo, '', { src: require('../../../assets/roostergrin_logo.svg') }),
    );
    return footer
  },

  initFormView() {
    const formElem = form.init();
    formElem.addEventListener('submit', (event) => {
      event.preventDefault();
      const patient = getFormData(formElem);
      const orthoconfirm = formElem.querySelector('#openchair-orthoconfirm select');
      if (orthoconfirm && orthoconfirm.value === 'no') {
        const officePhone = ctrl.getCurrentLocation().office_phone;
        ctrl.showError(`You can only book braces or invisalign consultation through this system.\nPlease call the office at ${officePhone.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1($2)$3-$4')} to book other types of appointments.`);
      }
      ctrl.setPatientInfo(patient);
      this.renderReviewView();
    });
    const bookingContainer = createEl('div', styles.bookingContainer);

    const infoContainer = createEl('div', styles.infoContainer);
    infoContainer.append(
      formElem,
      bookingContainer,
    );

    const goBackBtn = createBtn(styles.buttonCancel, '< Back');
    const booking = ctrl.getAppointmentInfo();
    let buttonText = ''
    if (booking) { buttonText = booking.automation ? 'Review Details' : 'Next' }
    const nextBtn = createEl('button', styles.buttonConfirm, buttonText, { type: 'submit' });
    nextBtn.addEventListener('click', onFormSubmissionClick)
    // submit button outside the form tag is not supported by ie
    // this is some hacking to work around that
    nextBtn.addEventListener('click', () => {
      // Google Analytics:
      if (process.env.NODE_ENV === 'production') {
        ga('openchair.send', {
          hitType: 'event',
          eventCategory: 'Form',
          eventAction: 'next',
        });
      }

      const submitInsideForm = nextBtn.cloneNode();
      formElem.appendChild(submitInsideForm);
      submitInsideForm.click();
      formElem.removeChild(submitInsideForm);
    });

    goBackBtn.addEventListener('click', widgetModal.onEditAppointmentClick);

    const buttonsContainer = createEl('div', styles.buttonsContainer);
    buttonsContainer.append(
      goBackBtn,
      nextBtn,
    );
    const formView = createEl('div', styles.appointmentInfoSubView);
    formView.append(
      infoContainer,
      buttonsContainer,
    );

    return {
      view: formView,
      render() {
        bookingContainer.innerHTML = '';
        bookingContainer.append(
          infoTables.booking.render(),
        );
      },
    };
  },

  initReviewView() {
    const booking = ctrl.getAppointmentInfo();
    const reviewMessage = createEl('div', styles.confirmMessage);
    const reviewText = booking.automation ?
      'Please review appointment details.'
      : 'Please review the information below to schedule your initial consultation:';
    reviewMessage.append(
      createEl('p', styles.confirmMessageLine, reviewText),
    );
    const bookingContainer = createEl('div', styles.bookingContainer);
    const editAppointmentBtn = createBtn(styles.buttonCancel, '< Edit appointment info');
    editAppointmentBtn.addEventListener('click', () => {
      // Google Analytics:
      if (process.env.NODE_ENV === 'production') {
        ga('openchair.send', {
          hitType: 'event',
          eventCategory: 'Form',
          eventAction: 'back',
        });
      }
      widgetModal.onEditAppointmentClick();
    });

    const patientContainer = createEl('div', styles.patientContainer);
    const editPatientBtn = createBtn(styles.buttonCancel, '< Edit patient info');
    editPatientBtn.addEventListener('click', () => {
      // Google Analytics:
      if (process.env.NODE_ENV === 'production') {
        ga('openchair.send', {
          hitType: 'event',
          eventCategory: 'Form',
          eventAction: 'back',
        });
      }
      this.renderFormView();
    });

    const infoContainer = createEl('div', styles.infoContainer);
    infoContainer.append(
      patientContainer,
      bookingContainer,
    );

    const buttonsContainer = createEl('div', styles.buttonsContainer);
    const innerContainer = createEl('div', 'innerContainer')
    const lookGood = createEl('div', styles.lookGood, 'Look good?')
    let buttonText = 'Submit'
    const submitButtonText = booking && booking.automation ? 'request appointment' : 'submit'
    const submitBtn = createEl('button', styles.buttonConfirm, submitButtonText);
    submitBtn.addEventListener('click', onRequestSubmission);
    innerContainer.append(
      lookGood,
      submitBtn
    )
    submitBtn.addEventListener('click', this.onSubmitClick.bind(this));
    buttonsContainer.append(innerContainer);

    const reviewView = createEl('div', styles.appointmentInfoSubView);
    reviewView.append(
      reviewMessage,
      infoContainer,
      buttonsContainer,
    );

    return {
      view: reviewView,
      render() {
        const infoTablesSection = infoTables.booking.render();
        const messageSection = infoTablesSection.querySelector('.openchair-message-section')
        if (messageSection) {
          messageSection.remove();
        }
        bookingContainer.innerHTML = '';
        bookingContainer.prepend(
          infoTablesSection,
          editAppointmentBtn,
        );
        patientContainer.innerHTML = '';
        patientContainer.prepend(
          infoTables.patient.render(),
          editPatientBtn,
        );
      },
    };
  },

  confirmationMessage(booking) {
    const location = ctrl.getCurrentLocation()
    const timeText = moment(booking.start_datetime).format('ddd, MMM Do')
    const automation = booking && booking.automation;
    const secondLine = automation
      ? ''
      : 'An email confirmation has been sent with your appointment information. ';
    const thirdLine = automation
      ? `Thank you for requesting an appointment on ${timeText} at ${location.name}. The details of your request have been emailed to you. You will be receiving a second email shortly to confirm your exact appointment time.`
      : 'We look forward to meeting you on ';
    return ['Congratulations on taking the first step toward a beautiful new smile! ', secondLine, thirdLine];
  },

  initConfirmationView() {
    const confirmationMessage = createEl('div', styles.confirmMessage, '', {
      style: 'position: relative; top: 12%;',
    });
    const timeMessage = createEl('p', styles.confirmMessageLine, '', { style: 'font-weight: bold;' });
    const booking = ctrl.getAppointmentInfo();
    const [ firstLine, secondLine, thirdLine ] = this.confirmationMessage(booking);
    confirmationMessage.append(
      createEl('p', styles.confirmMessageLine, firstLine, { style: 'display: block' }),
      createEl('p', styles.confirmMessageLine, secondLine),
      createEl('p', styles.confirmMessageLine, thirdLine),
      booking && !booking.automation ? timeMessage : '',
    );

    const calendarButtons = createEl('div', styles.calendars);
    const addToCalendarBtn = createEl('button', styles.buttonConfirm, 'Add to Calendar');
    addToCalendarBtn.addEventListener('click', () => {
      calendarButtons.innerHTML = '';
      calendarButtons.append(this.renderCalendarButtons());
      calendarButtons.style.display = 'flex';
      addToCalendarBtn.style.display = 'none';
    });
    const buttonsContainer = createEl('div', styles.buttonsContainer);
    buttonsContainer.append(
      addToCalendarBtn,
      calendarButtons,
    );
    const confirmationView = createEl('div', styles.appointmentInfoSubView);
    confirmationView.append(
      confirmationMessage,
      buttonsContainer,
    );


    return {
      view: confirmationView,
      render() {
        const datetime = moment.tz(ctrl.getAppointmentInfo().start_datetime, ctrl.getTz());
        timeMessage.textContent = `${datetime.format('dddd, MMMM D YYYY')} at ${datetime.format('h:mm A')}.`;

        calendarButtons.style.display = 'none';
        addToCalendarBtn.style.display = 'block';
      },
    };
  },

  renderCalendarButtons() {
    const event = makeCalendarEvent();
    const tz = ctrl.getTz();
    const buttonsFragment = document.createDocumentFragment();
    buttonsFragment.append(
      createCalIcon('Google', require('../../../assets/google_icon.png'), addToCalendar.google(event, tz)),
      createCalIcon('Apple', require('../../../assets/apple_icon_gray.png'), addToCalendar.ics(event, tz)),
      createCalIcon('Outlook', require('../../../assets/outlook_icon_blue.png'), addToCalendar.ics(event, tz)),
    );
    return buttonsFragment;
  },

  onSubmitClick() {
   // Google Analytics:
    if (process.env.NODE_ENV === 'production') {
      ga('openchair.send', {
        hitType: 'event',
        eventCategory: 'Form',
        eventAction: 'submit',
      });
    }
    widgetModal.toggleSpinner();
    ctrl.confirmBooking()
    .then(() => {
      this.renderConfirmationView();
      setTimeout(widgetModal.toggleSpinner.bind(widgetModal), 100);
    }).catch((err) => {
      setTimeout(widgetModal.toggleSpinner.bind(widgetModal), 100);
      ctrl.showError();
      Raven.captureException(err);
    });
  },

  clearForm() {
    form.render();
  },

  buildFormView() {
    if (this.formView) {
      this.formView.view.remove();
    }
    this.formView = this.initFormView();
    this.appointmentInfoView.append(
      this.formView.view,
    );
  },

  buildReviewView() {
    if (this.reviewView) {
      this.reviewView.view.remove();
    }
    this.reviewView = this.initReviewView();
    this.appointmentInfoView.append(
      this.reviewView.view,
    );
  },

  buildConfirmationView() {
    if (this.confirmationView) {
      this.confirmationView.view.remove();
    }
    this.confirmationView = this.initConfirmationView();
    this.appointmentInfoView.append(
      this.confirmationView.view,
    );
  },

  renderFooter() {
    if (this.footer) {
      this.footer.remove();
    }
    this.footer = this.initFooter();
    this.appointmentInfoView.append(
      this.footer,
    );
  },

  renderFormView() {
    this.formView.render();
    this.confirmationView.view.style.display = 'none';
    this.reviewView.view.style.display = 'none';
    this.formView.view.style.display = 'flex';
  },

  renderReviewView() {
    this.reviewView.render();
    this.confirmationView.view.style.display = 'none';
    this.formView.view.style.display = 'none';
    this.reviewView.view.style.display = 'flex';
  },

  renderConfirmationView() {
    this.confirmationView.render();
    this.formView.view.style.display = 'none';
    this.reviewView.view.style.display = 'none';
    this.confirmationView.view.style.display = 'flex';
  },

  render() {
    this.buildFormView();
    this.buildReviewView();
    this.buildConfirmationView();
    this.renderFooter();
    this.renderFormView();
  },
};

export default appointmentView;



// WEBPACK FOOTER //
// ./src/views/appointmentView/index.js